import { useRouteMatch } from 'react-router-dom';
import { SidebarItem } from '@accure/ui';

export type AppSidebarItemProps = {
  to: string;
  children: React.ReactNode;
};

export function AppSidebarItem({ to, children }: AppSidebarItemProps) {
  const match = useRouteMatch({ path: to, exact: to === '/' });
  return (
    <SidebarItem to={to} current={Boolean(match)}>
      {children}
    </SidebarItem>
  );
}
